import { URLS } from '../utils/urls';
import api from './client';

export const intermediaryService = {
    addIntermediary: async (credentials) => {
        const response = await api.post('intermediaries', credentials);
        return response.data;
    },
    getAllIntermediaries: async () => {
        const response = await api.get('intermediaries', { base_URL: URLS.baseApi });
        return response.data;
    },
    updateIntermediary: async (id, credentials) => {
        const response = await api.put(`intermediaries/${id}`, credentials);
        return response.data;
    },
    deleteIntermediary: async (id) => {
        const response = await api.delete(`intermediaries/${id}`);
        return response.data;
    },
};